import { Inject, Injectable } from '@angular/core';
import { AppSettings } from '../constants';
import { ClientEnvironment, ENVIRONMENT, MainNavigationItem } from '../environment';
import { NavigationEntry, NavigationItem } from '../models';
import { UserAccessService } from '../user-access/user-access.service';

@Injectable({ providedIn: 'root' })
export class NavigationItemsService {
  constructor(
    @Inject(ENVIRONMENT) private env: ClientEnvironment,
    private readonly userAccessService: UserAccessService,
  ) {}

  getNavigation() {
    const hiddenMenus = this.env.hideMainNavigationMenus ?? [];
    const entries: NavigationEntry[] = JSON.parse(JSON.stringify(AppSettings.APP_CONFIG.navigation)).filter((navItem: NavigationEntry) => {
      if (!navItem.visible || navItem.menuId == 0) {
        return false;
      }

      if (hiddenMenus.includes(navItem.text as MainNavigationItem)) {
        return false;
      }

      const isGlobalRoleActive = navItem.globalRole ? this.userAccessService.hasRole(navItem.globalRole) : true;
      if (isGlobalRoleActive) {
        // Filter out items that require a specific role
        navItem.items = navItem.items?.filter((item: NavigationItem) => {
          if (item.key === 'admin_tags' && !this.env.feature?.tagGroups) {
            return false;
          }

          let isRoleActive = item.accessRole ? this.userAccessService.hasRole(item.accessRole) : true;
          isRoleActive = item.globalRole ? this.userAccessService.hasRole(item.globalRole) : isRoleActive;
          return isRoleActive;
        });
      }
      return isGlobalRoleActive;
    });

    return entries;
  }
}
